import $ from 'jquery';
import BaseClass from '../base/BaseClass';
import Util from '../util/Util';

/**
 * 画像 SP<->PC 切り替えクラス
 * @example
 * //対象：画像
 * <img class="js-imageChange" src="/image/common/s.gif" data-src="/image/common/test.png">
 *      pc->/image/common/test.png
 *      sp->/image/common/sp/test.png
 *
 * //PCとSPでファイル名や拡張子が違う場合
 * <img class="js-imageChange" src="/image/common/s.gif" data-src="/image/common/test.png" data-src_sp="/image/common/sp/test2.png">
 *
 * @example
 * //対象：背景
 * <div class="js-imageChange_bg" data-src="/image/common/test.png"></div>
 *
 * //PCとSPでファイル名や拡張子が違う場合
 * <div class="js-imageChange_bg" data-src="/image/common/test.png" data-src_sp="/image/common/sp/test2.png"></div>
 *
 */
export default class ImageChangeClass extends BaseClass {
  constructor() {
    super();
    this.name = 'ImageChangeClass';

    this.EVENT_LOADEND = 'eventLoadend';
    this.spSize = Util.BREAK_POINT;
    this.target;
    this.windowSize;

    this.items;
    this.nMax = 0;
    this.count = 0;
    this.imgObj = [];
  }

  /**
     * 生成開始時
     * @param {String} _target 対象となるクラス名やid名 デフォルトbody
     */
  onCreate(_target) {
    this.target = (_target) ? _target : $('body');
  }

  onLoad() {
    this.items = $('.js-imageChange,.js-imageChange_bg', this.target);
    if (this.items.length === 0) { this.jq.trigger(this.EVENT_LOADEND); }
    this.onChangeBreakPoint();
  }

  onChangeBreakPoint(_b) {
    if (!this.items) { return; }

    let windowWidth = this.windowSize.w;
    for (let k in this.imgObj) {
      this.imgObj[k].onload = null;
      this.imgObj[k].onerror = null;
    }
    this.imgObj = [];
    this.count = 0;
    this.nMax = 0;

    let self = this;
    this.items.each((index, element) => {
      let _this = $(element);
      let src = _this.attr('data-src');
      let cl = _this.attr('class');
      if (!src) { return true; }
      let cSrc = null;
      if (cl.indexOf('both') !== -1) {
        self.addSrc(_this, src, cl);
        cSrc = src;
      } else if (windowWidth <= self.spSize && cl.indexOf('onlyPc') === -1) {
        let spsrc = _this.attr('data-src_sp');
        cSrc = (spsrc) ? spsrc : Util.getSpImagePath(src);
        self.addSrc(_this, cSrc, cl);
      } else if (windowWidth > self.spSize && cl.indexOf('onlySp') === -1) {
        self.addSrc(_this, src, cl);
        cSrc = src;
      }

      if (!cSrc) { return true; }
      self.nMax++;

      let callback = (a, b, c) => {
        self.count++;
        _this.css({ visibility: 'visible' });
        if (self.count >= self.nMax) {
          self.jq.trigger(self.EVENT_LOADEND);
        }
      };
      self.imgObj[index] = new Image();
      self.imgObj[index].onload = callback;
      self.imgObj[index].onerror = callback;
      self.imgObj[index].src = cSrc;

    });

    if (self.nMax === 0) {
      self.jq.trigger(self.EVENT_LOADEND);
    }
  }

  onResize(size) {
    this.windowSize = size;
  }

  addSrc(_target, _src, _cl) {
    if (_cl.indexOf('js-imageChange_bg') !== -1) {
      _target.css({ 'background-image': 'url(' + _src + ')' });
    } else {
      _target.attr('src', _src);
    }
  }
}
